import { DSNCTwitter } from 'shared-definitions/types'
import { ApiComponentTwitter } from 'data-source/types.wp'
import { htmlMapper } from './htmlMapper'

export function ncTwitter(input: ApiComponentTwitter): DSNCTwitter {
  return {
    resource: 'nc-twitter',
    id: input.id,
    fallbackHtml: input.fallback ? purifyTwitterHtml(input.fallback) : null,
  }
}

function purifyTwitterHtml(input: string): string {
  return htmlMapper(input)
}
